// Single source for the landing FAQ and its FAQPage JSON-LD (build.ts).
// Plain facts only (DESIGN.md: voice).

import { LAUNCH_FEE_SOL } from "./fees";

export const FAQ: { q: string; a: string }[] = [
  {
    q: "What is Moonlauncher?",
    a: "Software that connects your AI agent to pump.fun. Your agent prepares a token launch with Moonlauncher's MCP server, and you review and sign it on moonlauncher.app. The launch itself happens on pump.fun.",
  },
  {
    q: "Do you hold my keys or funds?",
    a: "No. You connect your own wallet and approve every transaction in it. Moonlauncher never sees your private key or recovery phrase and cannot move your funds.",
  },
  {
    q: "What does it cost?",
    a: `One flat ${LAUNCH_FEE_SOL} SOL fee per launch. That's all Moonlauncher charges. pump.fun's own fees and rent are the same as launching there directly, and every amount is shown on its own line before you sign.`,
  },
  {
    q: "Do I get a website for my token?",
    a: "Yes, free. Moonlauncher makes a simple page at yourticker.moonlauncher.app with your token's image, story, links and contract address, and uses it as your token's website link. It goes live when your token launches. You can skip it or use your own site instead.",
  },
  {
    q: "Which AI agents work?",
    a: "Any MCP client that supports remote servers, including Claude Code, Claude, Cursor, VS Code, ChatGPT, Codex, Gemini CLI, Windsurf and opencode. Add https://moonlauncher.app/mcp as a server and ask your agent to launch a token.",
  },
  {
    q: "Do you take a cut of my tokens or creator fees?",
    a: "No. You keep every token you buy and all the creator fees pump.fun pays on trades of your token, the same as launching on pump.fun directly. Moonlauncher's only income is the flat launch fee.",
  },
  {
    q: "Can my agent launch a token without me?",
    a: "No. The agent only prepares the launch and gets an approval link. Nothing happens on-chain until you open the link on moonlauncher.app and approve the transaction in your wallet.",
  },
  {
    q: "Can I try it without real SOL?",
    a: "Yes. staging.moonlauncher.app runs the full flow on Solana devnet with free test SOL.",
  },
];
